export const useIsKeyboardVisible = (): boolean => false
